module.exports = __webpack_public_path__ + "img/diabetes-log_B09JBKPTYJ.69282991.jpg";